<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            câu hỏi pháp luật</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <label>Câu hỏi:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Câu hỏi..." v-model="search.cCauHoi" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Tất cả" v-model="search.nTrangThai">
                  <el-option label="Tất cả" value="" selected></el-option>
                  <el-option label="Hoạt động" value="1" selected></el-option>
                  <el-option label="Đã xóa" value="0" selected></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6">
            <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_news">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm Câu hỏi</span>
            </el-button>
          </div>
          <!-- <div class="col-md-6" style="text-align:right">
                <el-button plain icon="el-icon-refresh" size="small" style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                  v-loading.fullscreen.lock="isLoading"></el-button>
              </div> -->
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="nMaCauHoiPhapLuat" show-overflow-tooltip class="text-nowrap" label="Mã"
              align="center" width="80">
            </el-table-column>
            <el-table-column prop="cCauHoi" show-overflow-tooltip class="text-nowrap" label="Câu hỏi">
            </el-table-column>
            <el-table-column prop="dNgayTao" label="Ngày tạo" align="center" width="120">
              <template #default="scope">
                {{ momentDate(scope.row.dNgayTao) }}
              </template>
            </el-table-column>
            <el-table-column prop="nTrangThai" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.nTrangThai == 1" size="small">Hoạt động</el-tag>
                <el-tag type="danger" v-if="scope.row.nTrangThai == 0" size="small">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Hành động" align="center" width="150">
              <template #default="scope">
                <el-button plain type="primary" :disabled="scope.row.nTrangThai == 0" data-bs-toggle="modal"
                  data-bs-target="#modal_news" @click="handleOpenEdit(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button>
                <el-button plain type="danger" :disabled="scope.row.nTrangThai == 0"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_news" ref="newsModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-1000px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_news_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ !operation ? "Thêm câu hỏi" : "Cập nhật câu hỏi" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body mh-600px overflow-scroll">
            <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="120px" class=" d-flex flex-column">
              <el-form-item label="Câu hỏi" prop="cCauHoi">
                <el-input v-model="formData.cCauHoi" />
              </el-form-item>
              <el-form-item label="Danh sách đáp án" prop="listPDapAnPhapLuat">
                <el-table :data="formData.listPDapAnPhapLuat" header-row-class-name="thead-light" style="height: 100%"
                  border max-height="250px" height="100%" fit stripe highlight-current-row>
                  <el-table-column prop="cDapAn*" show-overflow-tooltip class="text-nowrap" label="Đáp án(*)"
                    header-align="center">
                    <template #default="scope">
                      <el-input v-model="scope.row.cDapAn" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="nThuTu" show-overflow-tooltip class="text-nowrap" label="Thứ tự(*)" align="center"
                    width="120">
                    <template #default="scope">
                      <el-input type="number" v-model="scope.row.nThuTu" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="nTrangThai" label="Trạng thái" width="120" align="center">
                    <template #default="scope">
                      <el-tag type="success" v-if="scope.row.nTrangThai == 1" size="small">Hoạt động</el-tag>
                      <el-tag type="danger" v-if="scope.row.nTrangThai == 0" size="small">Sẽ xóa</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="Hành động" align="center" width="150">
                    <template #header>
                      <div style="display: flex; align-items: center; gap: 8px; justify-content: end;">
                        <el-button type="primary" @click="handleAddAnswer"><i class="fa fa-plus"
                            style="margin-right: 5px;"></i> Thêm đáp
                          án</el-button>
                      </div>
                    </template>
                    <template #default="scope">
                      <el-button plain type="danger" :disabled="scope.row.nTrangThai == 0"
                        v-loading.fullscreen.lock="isLoading" @click="handleDeleteAnswer(scope.$index)">
                        <span class="btn-inner--icon"><i class="fa fa-times"></i></span>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="Đáp án đúng" prop="pDapAnPhapLuat">
                <el-select v-model="formData.pDapAnPhapLuat" placeholder="Chọn đáp án đúng"
                  @change="console.log(formData.pDapAnPhapLuat)">
                  <el-option v-for="item, index in formData.listPDapAnPhapLuat.filter(val => val.nTrangThai == 1)"
                    :key="index" :label="item.cDapAn" :value="index"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Thêm</el-button>
              <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Lưu</el-button>
              <el-button plain type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">
      <img class="mh-500px mw-1000px" :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog> -->
  </div>
</template>
<script>
import { LawQuestions } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { ElMessage } from "element-plus";
import { el } from "element-plus/es/locale";
export default {
  name: 'LawQuestions',
  data() {
    return {
      search: {
        cCauHoi: null,
        cSdt: null,
        dNgayHen: null,
        nTrangThai: null,
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        nMaCauHoiPhapLuat: null,
        cCauHoi: null,
        listPDapAnPhapLuat: [],
        pDapAnPhapLuat: null,
        nTrangThai: 1,
      },
      rules: {
        cCauHoi: [{ required: true, message: "Xin vui lòng điền họ và tên", trigger: "blur" }],
        listPDapAnPhapLuat: [
          {
            validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                return callback(new Error('Dữ liệu không hợp lệ'));
              }

              const hasInvalid = value.some((item, index) => {
                if (
                  item.cDapAn === null ||
                  item.cDapAn === '' ||
                  item.nThuTu === null ||
                  item.nThuTu === ''
                ) {
                  return true;
                }
                return false;
              });

              if (hasInvalid) {
                callback(new Error('Vui lòng nhập đầy đủ "Đáp án" và "thứ tự" cho tất cả đáp án'));
              } else {
                callback();
              }
            },
            trigger: 'blur' // or 'change', depending on your component behavior
          }
        ],
        pDapAnPhapLuat: [{ required: true, message: "Xin vui lòng chọn đáp án đúng", trigger: "blur" }],
      },
      tableData: {
        content: []
      },
      PhongBans: [],
      isLoading: false,
      modalVisible: false,
      operation: false,
      iframeURL: "",
      openIframe: false,
      isSearchLoading: false,
      store: useStore(),
      dialogImageUrl: null,
      dialogVisible: false,
    }
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenAdd() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = false
      this.formData = {
        nMaCauHoiPhapLuat: null,
        cCauHoi: null,
        listPDapAnPhapLuat: [],
        pDapAnPhapLuat: null,
        nTrangThai: 1,
      }
    },
    handleAddAnswer() {
      this.formData.listPDapAnPhapLuat.push({
        cDapAn: null,
        nThuTu: this.formData.listPDapAnPhapLuat.length + 1,
        nTrangThai: 1,
      })
    },

    async handleDeleteAnswer(val) {
      const data = await this.formData.listPDapAnPhapLuat.filter(val => val.nTrangThai == 1)
      const correct = await data[this.formData.pDapAnPhapLuat]
      this.formData.listPDapAnPhapLuat[val].nTrangThai = await 0
      const data2 = await this.formData.listPDapAnPhapLuat.filter(val => val.nTrangThai == 1)
      if (correct == this.formData.listPDapAnPhapLuat[val] || this.formData.pDapAnPhapLuat == null) {
        this.formData.pDapAnPhapLuat = await null
      } else {
        this.formData.pDapAnPhapLuat = await data2.indexOf(correct) == -1 ? null : data2.indexOf(correct)
      }

    },
    handleOpenEdit(val) {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = true
      this.formData = Object.assign({}, val)
      this.formData.listPDapAnPhapLuat = JSON.parse(JSON.stringify(val.listPDapAnPhapLuat))
    },
    handleClose() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = false
      hideModal(this.$refs.newsModalRef)
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa câu hỏi này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(LawQuestions.deleteLawQuestions, val.nMaCauHoiPhapLuat).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa câu hỏi thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa câu hỏi thất bại", type: "error" });
          })
        }).catch(() => {

        })
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cCauHoi: { value: this.search.cCauHoi },
        nTrangThai: { value: this.search.nTrangThai },
      }
      this.store.dispatch(LawQuestions.findPageLawQuestions, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
          this.tableData.content.map((item) => {
            item.pDapAnPhapLuat = item.listPDapAnPhapLuat.indexOf(item.listPDapAnPhapLuat.filter(val => val.nMaDapAnPhapLuat == item.nDapAnDung)[0])
          })
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm câu hỏi thất bại", type: "error" });
      })
    },
    handleSave() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid)
          this.$confirm("Bạn có muốn lưu câu hỏi này không?", "Xác nhận", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            type: "warning",
          }).then(() => {

            const formData = new FormData()
            formData.append("record", new Blob([JSON.stringify(this.formData)], { type: "application/json" }))
            if (this.operation) {
              this.store.dispatch(LawQuestions.saveLawQuestions, {
                ...this.formData,
                pDapAnPhapLuat: this.formData.listPDapAnPhapLuat.filter(val => val.nTrangThai == 1)[this.formData.pDapAnPhapLuat]
              }).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Cập nhật câu hỏi thành công", type: "success" })
                } else {
                  ElMessage({ message: "Cập nhật câu hỏi không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Cập nhật câu hỏi không thành công", type: "error" })
              })
            } else {
              this.store.dispatch(LawQuestions.saveLawQuestions, {
                ...this.formData,
                pDapAnPhapLuat: this.formData.listPDapAnPhapLuat.filter(val => val.nTrangThai == 1)[this.formData.pDapAnPhapLuat]
              }).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Thêm câu hỏi mới  thành công", type: "success" })
                } else {
                  ElMessage({ message: "Thêm câu hỏi mới không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Thêm câu hỏi mới không thành công", type: "error" })
              })
            }
          }).catch(() => {

          })
      })
    },
    /* handleGetPhongBan() {
      this.store.dispatch(Department.listDepartment, { pageSize: 500, pageNum: 1 }).then(res => {
        if (res.code == 200) {
          this.PhongBans = res.data.content
        } else {
          ElMessage({ message: "Lấy danh sách câu hỏi thất bại", type: "error" });
        }
      }).catch((error) => {
        ElMessage({ message: "Lấy danh sách câu hỏi thất bại", type: "error" });
      })
    },
    getTenPhongBan(val) {
      const phongBan = this.PhongBans.find(item => item.nMaPhongBan == val)
      return phongBan ? phongBan.cTenPhongBan : ""
    }, */
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss"></style>